
import { useState, useCallback, useEffect } from "react";
import { trackEvent } from "@/lib/analytics/track-event";

interface FormData {
  name: string;
  email: string;
  company: string;
  message: string;
}

interface Guest {
  name: string;
  email: string;
  phone: string;
}

export const useBookingFormState = (meetingLinkId: string) => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    company: "",
    message: ""
  });
  
  const [customAnswers, setCustomAnswers] = useState<Record<string, string>>({});
  const [guests, setGuests] = useState<Guest[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [bookingId, setBookingId] = useState<string | null>(null);
  const [hasTrackedFormStart, setHasTrackedFormStart] = useState(false);

  // Track form start event
  useEffect(() => {
    if (!hasTrackedFormStart) {
      trackEvent({
        name: "booking_form_started",
        properties: {
          meetingLinkId,
          source: "direct"
        }
      });
      setHasTrackedFormStart(true);
    }
  }, [hasTrackedFormStart, meetingLinkId]);

  const handleInputChange = useCallback((field: keyof FormData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  }, []);

  const handleCustomAnswerChange = useCallback((questionId: string, value: string) => {
    console.log(`[useBookingFormState] Setting custom answer for ${questionId}:`, value);
    setCustomAnswers(prev => ({ ...prev, [questionId]: value }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData({ name: "", email: "", company: "", message: "" });
    setCustomAnswers({});
    setGuests([]);
    setBookingId(null);
  }, []);

  return {
    formData,
    customAnswers,
    guests,
    isSubmitted,
    bookingId,
    setGuests,
    setIsSubmitted,
    setBookingId,
    handleInputChange,
    handleCustomAnswerChange,
    resetForm
  };
};
